<div cdkOverlayOrigin #trigger="cdkOverlayOrigin"
    [attr.title]="displayText()"
    class="w-full min-w-0 flex justify-between items-center gap-2 border rounded-md px-3 text-sm transition-colors select-none"
    [class]="
        (disabled() ? 'bg-gray-200 border-gray-300 text-gray-500 cursor-not-allowed' :
            (invalid() ? 'border-red-500 ring-1 ring-red-500/20 bg-blue-50/50 text-gray-900 cursor-pointer' :
                (open() ? 'border-blue-500 ring-1 ring-blue-500/20 bg-blue-50/50 text-gray-900 cursor-pointer' : 'border-gray-300 bg-blue-50/50 text-gray-900 cursor-pointer hover:border-blue-400'))) +
        ' ' + (showChips() ? 'min-h-[42px] h-auto py-1.5' : 'h-[42px] min-h-[42px] py-2') + ' ' + triggerClass()
    "
    [style.min-height.px]="42"
    [style.height]="showChips() ? 'auto' : '42px'"
    (click)="toggle(); $event.stopPropagation()"
>
    @if (showChips()) {
        <div class="flex flex-wrap items-center gap-1.5 min-w-0 flex-1 py-0.5">
            @for (chip of visibleSelectedChips(); track chip.value) {
                <span
                    class="inline-flex items-center gap-1 rounded-md py-0.5 text-xs font-medium bg-blue-100 border border-blue-200 text-blue-900 pl-2 pr-1"
                >
                    <span class="break-all max-w-[200px]">{{ chip.label }}</span>
                    @if (!disabled()) {
                        <button
                            type="button"
                            class="inline-flex items-center justify-center w-3.5 h-3.5 rounded-full text-blue-700 hover:text-red-600 hover:bg-blue-200/50 cursor-pointer"
                            (click)="removeSelected(chip.value, $event)"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="w-3 h-3">
                                <path d="M6 6l12 12M18 6 6 18" />
                            </svg>
                        </button>
                    }
                </span>
            }
            @if (remainingChipsCount() > 0) {
                <span class="inline-flex items-center px-2 py-0.5 rounded-md bg-blue-200/70 border border-blue-300 text-blue-900 text-xs font-semibold">
                    +{{ remainingChipsCount() }} more
                </span>
            }
        </div>
    } @else {
        <span class="truncate leading-normal flex-1 text-left" [class]="selectedValues().length === 0 ? 'font-normal text-gray-400' : 'font-normal text-gray-900'">{{ displayText() }}</span>
    }

    <div class="flex items-center gap-1 shrink-0 self-center">
        @if (!disabled() && clearable() && selectedValues().length > 0 && !multiple()) {
            <button type="button" class="p-0.5 text-gray-400 hover:text-red-500 rounded-full hover:bg-red-50 transition-colors cursor-pointer" (click)="clear($event)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-3.5 h-3.5">
                    <path d="M18 6 6 18" />
                    <path d="m6 6 12 12" />
                </svg>
            </button>
        }
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-3.5 h-3.5 text-gray-500 transition-transform duration-200" [class.rotate-180]="open()">
            <path d="m6 9 6 6 6-6" />
        </svg>
    </div>
</div>

<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="open()"
    [cdkConnectedOverlayWidth]="trigger.elementRef.nativeElement.offsetWidth"
    [cdkConnectedOverlayViewportMargin]="10"
>
    <div class="mt-1 w-full max-w-full bg-white border border-gray-200 rounded-md shadow-lg z-[9999]" (click)="$event.stopPropagation()">
        <div class="p-2 border-b border-gray-100">
            <div class="relative">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-3.5 h-3.5 text-gray-400 absolute left-2.5 top-1/2 -translate-y-1/2">
                    <circle cx="11" cy="11" r="7" />
                    <path d="m21 21-4.3-4.3" />
                </svg>
                <input
                    #searchInput
                    type="text"
                    class="w-full border border-gray-300 rounded-md pl-7 pr-2 py-1.5 text-sm text-gray-700 bg-white focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500/20"
                    [placeholder]="searchPlaceholder()"
                    [ngModel]="searchTerm()"
                    (ngModelChange)="searchTerm.set($event)"
                />
            </div>
        </div>

        @if (multiple()) {
            <div class="flex items-center justify-between px-3 py-1.5 border-b border-gray-100 text-xs font-medium">
                <button type="button" class="text-blue-600 hover:text-blue-800 cursor-pointer" (click)="selectAllFiltered()">Select All</button>
                <button type="button" class="text-gray-500 hover:text-gray-700 cursor-pointer" (click)="unselectAll()">Unselect All</button>
            </div>
        }

        <div class="max-h-56 overflow-y-auto py-1">
            @if (filteredOptions().length === 0) {
                <p class="px-3 py-2 text-xs text-gray-400">No matches found</p>
            } @else {
                @for (option of filteredOptions(); track getRawValue(option)) {
                    <button
                        type="button"
                        class="w-full flex items-center gap-2 px-3 py-1.5 text-sm font-normal text-left cursor-pointer transition-colors"
                        [class]="option.disabled ? 'text-gray-400 cursor-not-allowed' : 'hover:bg-gray-50 text-gray-800' + (isSelected(getRawValue(option)) ? ' bg-blue-50 text-blue-700 font-medium' : '')"
                        [disabled]="option.disabled"
                        (click)="selectOption(option)"
                    >
                        @if (multiple()) {
                            <input type="checkbox" class="rounded border-gray-300 pointer-events-none text-blue-600 focus:ring-blue-500 accent-blue-600" [checked]="isSelected(getRawValue(option))" tabindex="-1" />
                        }
                        <span class="truncate">{{ getRawLabel(option) }}</span>
                    </button>
                }
            }
        </div>
    </div>
</ng-template>
